import { Col, InputNumber, Row, Typography } from 'antd'
import React, { FunctionComponent } from 'react'

import { inputNumberFormatter } from '../../utils/buybackHelpers'
import { LoanInput } from '../../utils/loanCalculatorHelpers'

const { Title, Text } = Typography

interface LoanCalculatorInputProps {
  loanInput: LoanInput
  onAmountChange: (value: number) => void
  onMonthsChange: (value: number) => void
  onInterestRateChange: (value: number) => void
}

export const LoanCalculatorInput: FunctionComponent<LoanCalculatorInputProps> =
  ({ loanInput, onAmountChange, onMonthsChange, onInterestRateChange }) => {
    return (
      <div>
        <Title level={4} className="mb-4">
          Vstupní parametry
        </Title>

        <Row gutter={[16, 16]}>
          <Col xs={24} md={8}>
            <div className="mb-2">
              <Text strong>Částka úvěru</Text>
            </div>
            <InputNumber
              value={loanInput.amount}
              onChange={value => onAmountChange(value || 0)}
              min={0}
              max={100000000}
              step={10000}
              formatter={inputNumberFormatter}
              addonAfter="Kč"
              className="w-full"
              size="large"
            />
          </Col>

          <Col xs={24} md={8}>
            <div className="mb-2">
              <Text strong>Délka úvěru</Text>
            </div>
            <InputNumber
              value={loanInput.months}
              onChange={value => onMonthsChange(value || 0)}
              min={1}
              max={600}
              step={6}
              addonAfter="měsíců"
              className="w-full"
              size="large"
            />
          </Col>

          <Col xs={24} md={8}>
            <div className="mb-2">
              <Text strong>Úroková míra p.a.</Text>
            </div>
            <InputNumber
              value={loanInput.interestRate}
              onChange={value => onInterestRateChange(value || 0)}
              min={0}
              max={100}
              step={0.1}
              precision={2}
              addonAfter="%"
              className="w-full"
              size="large"
            />
          </Col>
        </Row>
      </div>
    )
  }
